<template>
  <Wrap class="author-articles-list">
    <JournalContentList :author-id="authorId" />
  </Wrap>
</template>

<script lang="ts" setup>
  import { computed } from 'vue';
  import { useRoute } from 'vue-router';

  import JournalContentList from '@/pages/author/features/JournalContentList.vue';
  import Wrap from '@/shared/ui/Wrap.vue';

  const route = useRoute();

  const authorId = computed(() => Number(route.params.id));
</script>

<style lang="scss" scoped>
  .author-articles-list {
    margin-top: var(--alias-space-56);

    @include tablet {
      margin-top: var(--alias-space-40);
    }
  }
</style>
